import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const { page, ...filters } = criteria;

      const res = await axios.get(`${API_URL}/institutionsWorkers/groups`, {
        params: { page, ...filters?.filters },
      });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, institutionWorkersGroupId) {
      const res = await axios.get(
        `${API_URL}/institutionsWorkers/groups/${institutionWorkersGroupId}`,
      );

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { id, data }) {
      const res = await axios.put(`${API_URL}/institutionsWorkers/groups/${id}`, data);

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, data) {
      const res = await axios.post(`${API_URL}/institutionsWorkers/groups`, data);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async remove(_, id) {
      const res = await axios.delete(`${API_URL}/institutionsWorkers/groups/${id}`);

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getMembers(_, { institutionWorkersGroupId, criteria }) {
      const res = await axios.get(
        `${API_URL}/institutionsWorkers/groups/${institutionWorkersGroupId}/members`,
        {
          params: criteria,
        },
      );

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
